import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'child-cell',
  template: `
    <span>
      <i class="fa fa-edit edit text-primary" (click)="invokeParentMethod()"></i>
    </span>
  `,
  styles: [
    `
      .btn {
        line-height: 0.5;
      }
    `,
  ],
})
export class EditButtonRendererComponent implements ICellRendererAngularComp {
  public params: any;

  agInit(params: any): void {
    this.params = params;
  }

  public invokeParentMethod() {
    this.params.data['action'] = 'edit';
    this.params.context.componentParent.methodFromParent(
        this.params.data
    );
  }

  refresh(): boolean {
    return false;
  }
}